module.exports = __webpack_public_path__ + "img/pen.3d200f8d.svg";